import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Brain, MessagesSquare, Network } from 'lucide-react';
import { ProductDescriptionModal } from './ProductDescriptionModal';
interface HeroProps {
  onJoinBeta: () => void;
}
export const Hero = ({
  onJoinBeta
}: HeroProps) => {
  const navigate = useNavigate();
  const [showProductModal, setShowProductModal] = useState(false);
  const handleStart = () => {
    setShowProductModal(true);
  };
  const handleProductDescriptionComplete = () => {
    setShowProductModal(false);
    navigate('/auth');
  };
  return <>
      <div className="bg-gradient-to-b from-[#d5ff00]/10 to-white pt-24 pb-16" data-id="element-811">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16" data-id="element-812">
          <div className="text-center" data-id="element-813">
            <h1 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6" data-id="element-814">
              Because Cold Outreach Shouldn't Suck
              <br data-id="element-815" />
              <span className="text-[#6366f1]" data-id="element-816">For Anyone Involved</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-817">
              Let's be real—nobody likes generic spam. That's why we built an AI
              that actually gets it. Tell it what you're about, and watch it
              craft messages that don't make people want to block you.
            </p>
            <button onClick={handleStart} className="px-8 py-4 bg-[#d5ff00] text-gray-900 rounded-lg text-lg font-semibold hover:bg-[#c0e600] shadow-lg transform hover:scale-105 transition-all duration-200" data-id="element-818">
              Start Free
            </button>
            <p className="mt-4 text-sm text-gray-500" data-id="element-819">
              No credit card required
            </p>
          </div>
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-820">
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg border border-gray-100" data-id="element-821">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center mb-4" data-id="element-822">
                <Brain size={24} className="text-[#6366f1]" strokeWidth={2} data-id="element-823" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900" data-id="element-824">
                Actually Smart Targeting
              </h3>
              <p className="text-gray-600 text-center" data-id="element-825">
                Just chat about who you're looking for. Our AI does the tedious
                stalking for you
              </p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg border border-gray-100" data-id="element-826">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center mb-4" data-id="element-827">
                <MessagesSquare size={24} className="text-[#6366f1]" strokeWidth={2} data-id="element-828" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900" data-id="element-829">
                Messages That Don't Suck
              </h3>
              <p className="text-gray-600 text-center" data-id="element-830">
                No more "Hope this email finds you well" garbage. Each message
                is actually relevant
              </p>
            </div>
            <div className="flex flex-col items-center p-6 bg-white rounded-lg shadow-lg border border-gray-100" data-id="element-831">
              <div className="w-12 h-12 bg-[#d5ff00]/20 rounded-lg flex items-center justify-center mb-4" data-id="element-832">
                <Network size={24} className="text-[#6366f1]" strokeWidth={2} data-id="element-833" />
              </div>
              <h3 className="text-lg font-semibold mb-2 text-gray-900" data-id="element-834">
                One Dashboard to Rule Them All
              </h3>
              <p className="text-gray-600 text-center" data-id="element-835">
                LinkedIn, email, whatever—manage everything without losing your
                mind
              </p>
            </div>
          </div>
        </div>
      </div>
      <ProductDescriptionModal isOpen={showProductModal} onClose={() => setShowProductModal(false)} onComplete={handleProductDescriptionComplete} data-id="element-836" />
    </>;
};